import React, { useRef, useEffect } from 'react';
import './Gloves.scss';
import videomov from '../../../../assets/apollo/gloves/apollo_gloves.mov';
import video from '../../../../assets/apollo/gloves/apollo_gloves.webm';
import poster from '../../../../assets/apollo/gloves/apollo_gloves_poster.png';

function ApolloGloves({ apolloGlovesRef }) {
  const videoRef = useRef();
  useEffect(() => {
    videoRef.current.load();
    const videoCurrent = videoRef.current;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.5) {
              videoCurrent.play();
            }
          }
        });
      },
      { threshold: [0, 0.5] }
    );
    observer.observe(videoCurrent);
  }, []);

  return (
    <section className="gloves gloves" ref={apolloGlovesRef}>
      <div className="gloves__animation gloves__animation-apollo">
        <video
          muted
          playsInline
          preload="auto"
          ref={videoRef}
          className="gloves__animation__video"
          poster={poster}
        >
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
      <div className="gloves__text gloves__text-apollo">
        <h3 className="gloves__text__title gloves__text__title-apollo">
          Moonwalkers received gloves with curved fingers, to make it easier for them to grasp
          tools.
        </h3>
        <p className="gloves__text__copy">
          Despite a custom fit, astronauts complained of hand pain and difficulty working.
        </p>
      </div>
    </section>
  );
}

export default ApolloGloves;
